// Period filter presets and utilities
const PERIOD_PRESETS = [
  { key: "all", label: "Tutto" },
  { key: "this_month", label: "Questo mese" },
  { key: "last_month", label: "Mese scorso" },
  { key: "this_quarter", label: "Questo trimestre" },
  { key: "last_quarter", label: "Trimestre scorso" },
  { key: "this_year", label: "Quest'anno" },
  { key: "last_year", label: "Anno scorso" },
  { key: "custom", label: "Personalizzato" },
];

function getDateRange(preset) {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth(); // 0-indexed
  const pad = (n) => String(n).padStart(2, "0");
  const fmt = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

  switch (preset) {
    case "this_month":
      return { from: `${y}-${pad(m + 1)}-01`, to: fmt(now) };
    case "last_month": {
      const lm = m === 0 ? 11 : m - 1;
      const ly = m === 0 ? y - 1 : y;
      const lastDay = new Date(ly, lm + 1, 0).getDate();
      return { from: `${ly}-${pad(lm + 1)}-01`, to: `${ly}-${pad(lm + 1)}-${pad(lastDay)}` };
    }
    case "this_quarter": {
      const qStart = Math.floor(m / 3) * 3;
      return { from: `${y}-${pad(qStart + 1)}-01`, to: fmt(now) };
    }
    case "last_quarter": {
      let qStart = Math.floor(m / 3) * 3 - 3;
      let qy = y;
      if (qStart < 0) { qStart += 12; qy -= 1; }
      const qEnd = qStart + 2;
      const lastDay = new Date(qy, qEnd + 1, 0).getDate();
      return { from: `${qy}-${pad(qStart + 1)}-01`, to: `${qy}-${pad(qEnd + 1)}-${pad(lastDay)}` };
    }
    case "this_year":
      return { from: `${y}-01-01`, to: fmt(now) };
    case "last_year":
      return { from: `${y - 1}-01-01`, to: `${y - 1}-12-31` };
    default:
      return { from: "", to: "" };
  }
}

export { PERIOD_PRESETS, getDateRange };
